/**
 * Plans Component
 *
 * @constructor
 */

export default function()
{

    const toggles = document.querySelectorAll('[data-plan-toggle]')

    for(const toggle of toggles) {
        toggle.addEventListener('click', function(e) {
            const targetSelector = toggle.getAttribute('data-plan-toggle')
            const targets = document.querySelectorAll(targetSelector)
            for(const target of targets) {
                target.classList.toggle('active')
            }
            this.textContent= document.querySelector('.active[data-btn-text]').getAttribute('data-btn-text')
            e.preventDefault()
        })
    }

}
